<template>
  <div>
    <div v-if="forms.length === 0" class="text-center py-12">
      <div class="text-gray-400 text-lg mb-2">No pending forms</div>
      <p class="text-gray-400 text-sm">Forms will appear here when opportunities move to configured pipeline stages.</p>
    </div>
    <div v-else class="bg-white shadow rounded-lg overflow-hidden">
      <table class="min-w-full divide-y divide-gray-200">
        <thead class="bg-gray-50">
          <tr>
            <th class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Contact</th>
            <th class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Template</th>
            <th class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Pipeline / Stage</th>
            <th class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Created</th>
            <th class="px-6 py-3 text-right text-xs font-medium text-gray-500 uppercase tracking-wider"></th>
          </tr>
        </thead>
        <tbody class="bg-white divide-y divide-gray-200">
          <tr v-for="form in forms" :key="form.id" class="hover:bg-gray-50">
            <td class="px-6 py-4 whitespace-nowrap">
              <div class="text-sm font-medium text-gray-900">{{ form.contactName }}</div>
              <div v-if="form.contactEmail" class="text-xs text-gray-500">{{ form.contactEmail }}</div>
            </td>
            <td class="px-6 py-4 whitespace-nowrap text-sm text-gray-700">{{ templateName(form.templateId) }}</td>
            <td class="px-6 py-4 whitespace-nowrap text-sm text-gray-700">
              <template v-if="form.triggerType === 'call_completed'">
                <span class="inline-flex items-center px-2 py-0.5 rounded text-xs font-medium bg-indigo-100 text-indigo-800">Call Completed</span>
              </template>
              <template v-else>
                {{ form.pipelineName || form.pipelineId }}
                <span class="text-gray-400 mx-1">/</span>
                {{ form.stageName || form.stageId }}
              </template>
            </td>
            <td class="px-6 py-4 whitespace-nowrap text-sm text-gray-500">{{ formatDate(form.createdAt) }}</td>
            <td class="px-6 py-4 whitespace-nowrap text-right">
              <button
                @click="$emit('open', form)"
                class="inline-flex items-center px-3 py-1.5 border border-blue-600 text-sm font-medium rounded text-blue-600 bg-white hover:bg-blue-50 transition-colors"
              >Open</button>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
export default {
  name: 'PendingTable',
  props: {
    forms: { type: Array, required: true },
    templates: { type: Array, required: true }
  },
  emits: ['open'],
  methods: {
    templateName(id) {
      const t = this.templates.find(t => t.id === id)
      return t ? t.name : id
    },
    formatDate(iso) {
      if (!iso) return ''
      return new Date(iso).toLocaleDateString('en-US', {
        month: 'short', day: 'numeric', year: 'numeric', hour: 'numeric', minute: '2-digit'
      })
    }
  }
}
</script>
